import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/Button";

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-primary-blue/10 glass-nav">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3">
          <img 
            src="https://d4polyhz8pjtz.cloudfront.net/7192/novoprojeto-2025-02-11t160521319-20250211160537.png" 
            alt="Portal Ethics" 
            className="h-10 w-auto"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-10">
          <Link 
            to="/servicos" 
            className="text-sm font-semibold text-neutral-700 hover:text-primary-blue transition-colors"
          >
            Serviços
          </Link>
          <Link 
            to="/planos" 
            className="text-sm font-semibold text-neutral-700 hover:text-primary-blue transition-colors"
          >
            Planos
          </Link>
          <Link 
            to="/conteudo" 
            className="text-sm font-semibold text-neutral-700 hover:text-primary-blue transition-colors"
          >
            Conteúdo
          </Link>
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-4">
          <Link to="/dashboard">
            <Button variant="ghost" size="sm">
              Acessar Canal
            </Button>
          </Link>
          <Link to="/login">
            <Button size="sm">
              Login
            </Button>
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-20 left-0 right-0 bg-white border-b border-neutral-200 shadow-lg">
          <nav className="flex flex-col p-6 gap-4">
            <Link 
              to="/servicos" 
              className="text-sm font-semibold text-neutral-700"
              onClick={() => setIsMenuOpen(false)}
            >
              Serviços
            </Link>
            <Link 
              to="/planos" 
              className="text-sm font-semibold text-neutral-700"
              onClick={() => setIsMenuOpen(false)}
            >
              Planos
            </Link>
            <Link 
              to="/conteudo" 
              className="text-sm font-semibold text-neutral-700"
              onClick={() => setIsMenuOpen(false)}
            >
              Conteúdo
            </Link>
            <hr className="border-neutral-200" />
            <Link to="/dashboard" onClick={() => setIsMenuOpen(false)}>
              <Button variant="ghost" className="w-full justify-start">
                Acessar Canal
              </Button>
            </Link>
            <Link to="/login" onClick={() => setIsMenuOpen(false)}>
              <Button className="w-full">
                Login
              </Button>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
